import { useContext } from "react";
import { FormContext } from "../formContext";
import { defaultButtonText } from "../constants";
import { useSetWithDismountFallback } from "@hooks/useSetWithDismountFallback";

// note: if this hook doesnt finish firing (why wouldnt it??) we could have race condition issues
// with mounting pages. There must never be more than 1 consumer of this hook in the react virtual
// dom at any time
export const useSetButtonText = (buttonText) => {
  const { button: {setButtonText} } = useContext(FormContext);
  useSetWithDismountFallback(setButtonText, defaultButtonText, buttonText)
};